<template>
  <span v-if="parsedDescription" class="tw:text-gray-700">
    <template v-for="(text, idx) in parsedDescription">
      <a v-if="text.url" :key="'url-' + idx" :href="text.url" target="_blank" class="tw:text-nowrap">{{ text.text }}</a>
      <span v-else :key="idx" class="tw:text-nowrap">{{ text }}</span>
    </template>
  </span>
</template>

<script>
import { parseMarkdownUrlText } from '@/assets/js/utility';

export default {
  name: 'BasemapAttributionText',
  props: {
    description: {
      type: [String, null],
    },
  },
  computed: {
    parsedDescription() {
      return this.description ? parseMarkdownUrlText(this.description) : null;
    },
  },
};
</script>
